import {inject} from '@angular/core';
import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {DeviceDetectionService} from '../services/device-detection-service';

export const PendenzenDeviceGuard: CanActivateFn = () => {
    const router = inject(Router);
    if (inject(DeviceDetectionService).getDevice().device.type === 'mobile') {
        return new RedirectCommand(router.parseUrl('termin-mobile'));
    }
    return true;
};
